import { FilterParam as t } from "../../../types.js";
import { useMultiSelectionFilter as r } from "../components/MultiSelectionFilter/useMultiSelectionFilter/useMultiSelectionFilter.js";
import { TRANSACTION_CATEGORIES as T, DEFAULT_TRANSACTIONS_OVERVIEW_MULTI_SELECTION_FILTER_PARAMS as l, TRANSACTION_STATUSES as u } from "../components/MultiSelectionFilter/useMultiSelectionFilter/constants.js";
const F = (e, i) => {
  const a = r({
    filterParam: t.CATEGORIES,
    filterValues: T,
    defaultFilters: l,
    ...e
  }), s = r({
    filterParam: t.STATUSES,
    filterValues: u,
    defaultFilters: l,
    ...e
  }), S = r({
    filterParam: t.CURRENCIES,
    filterValues: i,
    defaultFilters: l,
    ...e
  });
  return {
    categoriesFilter: a,
    currenciesFilter: S,
    statusesFilter: s
  };
};
export {
  F as default
};
